module.exports = __webpack_public_path__ + "img/tb-04@2x.28ecde13.png";